import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExclusiveScoopSection from './components/ExclusiveScoopSection';
import HotGossipGrid from './components/HotGossipGrid';
import AppDownloadCta from './components/AppDownloadCta';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ExclusiveScoopSection />
        <HotGossipGrid />
        <AppDownloadCta />
      </main>
      <Footer />
    </>
  );
}